import { Injectable } from '@angular/core';
import type { MailingDefaultSendersFindInterface } from '@zaoblako/shared/modules/notification/dtos/mailing-settings/mailing-default-senders-find.dto';
import type { MailingDefaultSendersFormInterface } from '@zaoblako/shared/modules/notification/dtos/mailing-settings/mailing-default-senders-form.dto';
import { MailingFileDebtorTargetFormInterface } from '@zaoblako/shared/modules/notification/dtos/mailing/mailing-file-debtor-target-form.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BasisNotificationService extends BaseService {
  protected baseUrl = '/basis/notification';

  public debtorTargetsFromExcel(body: FormData): Observable<MailingFileDebtorTargetFormInterface[]> {
    return this.http.post<MailingFileDebtorTargetFormInterface[]>(`${this.baseUrl}/debtor-targets-from-excel`, body);
  }

  public getSettings(): Observable<MailingDefaultSendersFindInterface> {
    return this.http.get<MailingDefaultSendersFindInterface>(`${this.baseUrl}/mailing-settings`);
  }

  public setSettings(body: MailingDefaultSendersFormInterface): Observable<MailingDefaultSendersFindInterface> {
    return this.http.post<MailingDefaultSendersFindInterface>(`${this.baseUrl}/mailing-settings`, body);
  }
}
